/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import ZeroLinksWarningImage from "../../../assets/images/zero-links-warning";
import { notSelect } from "../../../styles/general";
import StyledButton from "../../StyledButton";
import StyledCheckBox from "../../StyledCheckBox";

const Container = styled.div`
  width: 450px;
  height: 100%;
  padding: 35px 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Title = styled.div`
  font: normal normal 600 18px Source Sans Pro;
  color: #333333;
  margin-top: 25px;
  margin-bottom: 18px;
`;
const Subtitle = styled.div`
  font: normal normal 400 16px/24px Source Sans Pro;
  color: #707070;
  text-align: center;
  margin-bottom: 18px;
`;
const ButtonsContainer = styled.div`
  display: flex;
  > :first-child {
    margin-right: 12.5px;
  }
`;
const NotRemindContainer = styled.div`
  display: flex;
  margin-top: 24.7px;
`;

const NotRemindText = styled.div`
  font-size: 15px;
  color: #707070;
  margin-left: 7px;
`;

interface Props {
  onConfirm: (remindInFuture: boolean) => void;
  onCancel: () => void;
  mode: "send" | "schedule";
}

export default function ZeroLinksWarningModal(props: Props) {
  const { onCancel, onConfirm, mode } = props;
  const [remindInFuture, setRemindInFuture] = useState(false);

  return (
    <Container>
      <ZeroLinksWarningImage width={120} height={91} />
      <Title>No Links Added</Title>
      <Subtitle>
        Before {mode === "send" ? "sending" : "scheduling"} this email, we just
        want to confirm
        <br /> that it is ready because there does not appear to be <br />a link
        in the email?
      </Subtitle>
      <ButtonsContainer>
        <StyledButton inverted onClick={onCancel}>
          Cancel
        </StyledButton>
        <StyledButton onClick={() => onConfirm(remindInFuture)}>
          {mode === "send" ? "Send" : "Schedule"}
        </StyledButton>
      </ButtonsContainer>
      <NotRemindContainer>
        <div css={notSelect}>
          <StyledCheckBox
            check={remindInFuture}
            handleCheck={() => setRemindInFuture(!remindInFuture)}
          />
        </div>
        <NotRemindText>Do not remind me of this in the future</NotRemindText>
      </NotRemindContainer>
    </Container>
  );
}
